import { render, staticRenderFns } from "./gj-country-select.vue?vue&type=template&id=25a18ab4&scoped=true&"
import script from "./gj-country-select.vue?vue&type=script&lang=js&"
export * from "./gj-country-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a18ab4",
  null
  
)

export default component.exports